import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Autoplay, Navigation, Pagination } from 'swiper';
import { useShoppingCart } from '../../context/ShoppingCartContext';
import { useGeral } from '../../context/GeralContext';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { LazyLoadImage } from 'react-lazy-load-image-component'

import './NewArrivals.css';
import logo from '../../assets/img-skeleton.png'
import { useTranslation } from 'react-i18next';

function NewArrivals(arr) {
    const { t } = useTranslation()
    const { tokenUser } = useGeral()
    const { openLogin, errorToast } = useShoppingCart()
    const [newProducts, setNewProducts] = useState<any[]>([]);
    const [swiperThumb, setSwiperThumb] = useState<any>(null)

    useEffect(() => {
        setNewProducts([...arr?.arr?.products_listings])
    }, []);

    function addToWishlist(event, product) {
        event.preventDefault()
        if (!tokenUser) {
            openLogin();
        } else {
            var myHeaders = new Headers();
            myHeaders.append("Authorization", "Bearer " + tokenUser);
            myHeaders.append("Content-Type", "application/json");

            let raw = JSON.stringify({
                "child_id": product.product_child_id
            });

            var requestOptions: RequestInit = {
                method: 'PUT',
                headers: myHeaders,
                body: raw,
                redirect: 'follow'
            };

            fetch(process.env.REACT_APP_URL + '/customers/wishlist', requestOptions)
                .then(async response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        var error = await response.text();
                        return Promise.reject({ status: response.status, message: error });
                    }
                })
                .then(result => {
                    var wish = false
                    if (result.find(p => product.product_child_id === p.product_child_id)) {
                        wish = true
                    }
                    setNewProducts([...newProducts.map((listing) =>
                        listing.product_child_id === product.product_child_id ? { ...listing, wishlisted: wish } : listing
                    )]);
                })
                .catch(error => {
                    errorToast(error)
                });
        }
    }

    return (
        <>
            <Swiper
                breakpoints={{
                    640: {
                        slidesPerView: 2,
                        slidesPerGroup: 2,
                    },
                    768: {
                        slidesPerView: 3,
                        slidesPerGroup: 3
                    },
                    1024: {
                        slidesPerView: process.env.REACT_APP_THEME == 'theme2' ? 3 : 5,
                        slidesPerGroup: process.env.REACT_APP_THEME == 'theme2' ? 3 : 5,
                    },
                }}
                slidesPerView={1}
                slidesPerGroup={1}
                spaceBetween={process.env.REACT_APP_THEME == 'theme2' ? 30 : 12}
                loop={false}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                onSwiper={setSwiperThumb}
                navigation={true}
                pagination={{ clickable: true }}
                modules={[Navigation, Pagination, Autoplay]}
            >
                {newProducts.map((product, index) => {
                    return <SwiperSlide key={index}>
                        <Link className="flex flex-col justify-between no-underline" to={'/product/' + product.product_id + '?variant=' + product.product_variant_id}>
                            <div className="group relative h-full w-full flex">
                                {/* <img
                                    src={product.photo ? product.photo : logo}
                                    alt={product.title}
                                    loading="lazy"
                                    className="w-full object-cover object-center group-hover:opacity-75"
                                /> */}
                                <LazyLoadImage
                                    src={product.photo}
                                    alt={product.title}
                                    width='100%'
                                    height='100%'
                                    loading="lazy"
                                    placeholderSrc={logo}
                                    className="absolute inset-0 h-full w-full object-contain object-bottom group-hover:opacity-75"
                                />
                                <div className="block-sizes absolute p-4 bottom-0 w-full hidden sm:group-hover:flex">
                                    <object className='w-full'><div className="bg-white p-3 w-full">
                                        <p className="mt-1 mb-2 text-sm font-small text-center">{t('new_arrivals.sizes')}</p>
                                        <div className='flex flex-wrap justify-center'>
                                            {product.Size?.map((size, index) => (
                                                <Link key={index} className='mx-2 my-1 no-underline text-sm hover:font-bold' to={'/product/' + product.product_id + '?variant=' + size.product_variant_id}>
                                                    <p>{size.O2Child}</p>
                                                </Link>
                                            ))}
                                        </div>
                                    </div></object>
                                </div>
                            </div>
                            <div className='list-product-details mt-4 flex flex-col'>
                                <div className='flex justify-between gap-3 overflow-hidden'>
                                    <div className="subtitle2 text-sm truncate">{product.title}</div>
                                    {/* <button className={(product.wishlisted ? 'heart' : '')}><HeartIcon className={'h-5 w-5 flex-shrink-0 hover:fill-black ' + (product.wishlisted ? "fill-red-500 stroke-red-500 hover:fill-red-500" : "stroke-black")} title={product.wishlisted ? "Remove from wishlist" : "Add to wishlist"} onClick={(e) => addToWishlist(e, product)}></HeartIcon></button> */}
                                </div>
                                <div className="colors flex mt-1 text-sm">{product?.option1array?.length} {product?.option1array?.length > 1 ? <span>&nbsp;{t('new_arrivals.colors_available')}</span> : <span>&nbsp;{t('new_arrivals.color_available')}</span>}</div>
                                <div className="price mt-1 text-lg font-medium">
                                    <div className="flex">{product.min_price}€{product.min_price !== product.max_price && product.max_price && <div>-{product.max_price}€</div>}</div>
                                </div>
                            </div>
                        </Link>
                    </SwiperSlide>
                })}
            </Swiper>
        </>
    )
}

export default NewArrivals;